
// Vue
import {Options, Vue} from "vue-class-component";

// Store
import store from "@/store";

// Vendors
import moment from "moment";

// Models
import {AppCoachDiagnosticsRootListIndex} from "@/models/app/coach/diagnostics/root/list/index";
import {AppCommonUser} from "@/models/app/common/User";
import {AppCommonDiagnosticCategory} from "@/models/app/common/diagnostic-category";
import {ResponseIndex} from "@/models/response";

// Components
import {
  ElRow,
  ElCol,
} from "element-plus";
import AppCoachDiagnosticsRootListFormCreateIndexVue from "@/views/app/coach/diagnostics/root/list/form/create.vue";
import AppCoachDiagnosticsRootListFormUpdateIndexVue from "@/views/app/coach/diagnostics/root/list/form/update.vue";
import AppCoachDiagnosticsRootListFormRemoveIndexVue from "@/views/app/coach/diagnostics/root/list/form/remove.vue";

// Services
import {getRequest} from "@/services/api/request";

@Options({
  props: [
    "players",
    "diagnosticCategories",
  ],
  components: {
    ElRow,
    ElCol,
    AppCoachDiagnosticsRootListFormCreateIndexVue,
    AppCoachDiagnosticsRootListFormUpdateIndexVue,
    AppCoachDiagnosticsRootListFormRemoveIndexVue,
  },
})
export default class AppCoachDiagnosticsRootListIndexVue extends Vue {
  isLoading: boolean | null = false;
  formData: any = {
    filter: {
      user_id: "*",
      diagnostic_category_id: "*",
      date: [
        moment(),
        moment().add(14, "days"),
      ],
    },
    organization_id: store.getters.getOrganizationMember.organization_id,
  };
  moment: any = null;

  players: Array<AppCommonUser> = [];
  diagnosticCategories: Array<AppCommonDiagnosticCategory> = [];

  diagnostics: Array<AppCoachDiagnosticsRootListIndex> = [];

  async getDiagnostics(formData: any = null): Promise<void> {
    this.isLoading = true;

    if (formData) {
      this.formData = formData;
    }

    await getRequest({
      uri: `/common/diagnostics`,
      formData: this.formData,
      isProtected: true,
    }).then((r: ResponseIndex) => {
      if (r.data) {
        this.diagnostics = r.data;
      }
    });
    this.isLoading = false;
  }

  async created(): Promise<void> {
    this.moment = moment;
    await this.getDiagnostics();
  }
}
